var _desc, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHotDog(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    "aria-labelledby": titleId,
    "aria-describedby": "desc",
    role: "img",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    strokeWidth: 3,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Hot Dog") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "A line styled icon from Orion Icon Library.")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "layer2",
    d: "M58.3 15.6l.8.8a10.1 10.1 0 0 1 0 14.2L30.6 59.1a10.1 10.1 0 0 1-14.2 0l-.8-.8m-9.9-9.9l-.7-.7a10.1 10.1 0 0 1 0-14.3L33.4 4.9a10.1 10.1 0 0 1 14.2 0l.8.8m2.1 7.8c1 2.8-.9 4.8-3.7 3.7S42.2 18 43 21s-.7 4.5-3.7 3.7-4.6.9-3.7 3.7-.9 4.6-3.7 3.7-4.5.9-3.7 3.7m-15 15c-.9-2.8.8-4.5 3.7-3.7s4.5-.8 3.7-3.7 1-4.7 3.7-3.7 4.7-1 3.7-3.7",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "layer1",
    d: "M19.2 56.2a8.1 8.1 0 0 1-11.4 0 8.1 8.1 0 0 1 0-11.4l37-37a8.1 8.1 0 0 1 11.4 0 8.1 8.1 0 0 1 0 11.4z",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotDog);
export default __webpack_public_path__ + "static/media/hot-dog.024e812d.svg";
export { ForwardRef as ReactComponent };